import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const ETDpdfDialog = ({ open, onClose, row }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle><b>HATI YA DHARURA</b></DialogTitle>
      <DialogContent>
        <div>
          {row ? (
            <iframe
              src={row}
              className="mdIframe2"
              title="etd PDF"
            />
          ) : (
            <p>Generating PDF...</p>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          className="btn popBtn"
          onClick={onClose}

        >
          <b>Funga</b>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ETDpdfDialog;
